module.exports = __webpack_public_path__ + "mobile/img/icon_logo.8ffebd41.png";